export default "__VITE_ASSET__CsGFrBag__"